module.exports = __webpack_public_path__ + "media/application/images/2022/digital-b41faa101691e0394dc2fee4ec75386b.png";